export enum TestOpsPlatformTierTypeV2 {
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
  ULTIMATE = 'ULTIMATE',
}
